// extracted by mini-css-extract-plugin
module.exports =  {"cell-icon-container":"CellWithIcon-module__cell-icon-container___HAm4e","icon-container":"CellWithIcon-module__icon-container___qs5pZ"};